module.exports = "<div class=\"content-loader\">\n  <div class=\"rect rect1\"></div>\n  <div class=\"rect rect2\"></div>\n  <div class=\"rect rect3\"></div>\n  <div class=\"rect rect4\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/common/contentLoader/contentLoader.html
// module id = 221
// module chunks = 1